/**
 * routers
 * 更多关于Router的使用，请参考以下教程
 * https://github.com/ReactTraining/react-router/blob/master/docs/guides/RouteConfiguration.md
 */

import Index from './Index';
import PageDone from './PageDone';
import WageIndex from './wage/Index';
import WageDetail from './wage/PageDetail';
import WageDetailBonus from './wage/PageDetailBonus';

const router = {
  path: 'home',
  breadcrumbName: '个人中心',
  childRoutes: [
    {
      path: 'gtasks',
      breadcrumbName: '所有待办',
      indexRoute: { component: Index },
    },
    {
      path: 'd_gtasks',
      breadcrumbName: '所有已办',
      indexRoute: { component: PageDone },
    },
    {
      path: 'wage',
      breadcrumbName: '工资条',
      indexRoute: { component: WageIndex },
      childRoutes: [
        {
          path: 'detail/:uuid',
          component: WageDetail,
        },
        {
          path: 'detailBonus/:uuid',
          component: WageDetailBonus,
        },
      ],
    },
  ],
};

export default router;



// WEBPACK FOOTER //
// ./src/components/home/router.js